import {createStore, applyMiddleware} from 'redux'
import logger from 'redux-logger'
import rootReducer from './index'
import thunk from 'redux-thunk'


function configureStore(){
    return createStore(rootReducer, applyMiddleware(thunk, logger))
}

export default configureStore;